export default "/profile/images/whatsapp_integration.png?c836b62e6f91372265f64cbdf264181c";